import { render, staticRenderFns } from "./DomainNodeProperties.vue?vue&type=template&id=7f19fa42&scoped=true"
import script from "./DomainNodeProperties.vue?vue&type=script&lang=js"
export * from "./DomainNodeProperties.vue?vue&type=script&lang=js"
import style0 from "./DomainNodeProperties.vue?vue&type=style&index=0&id=7f19fa42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19fa42",
  null
  
)

export default component.exports